<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <v-card>
          <v-tabs v-model="activeTab" background-color="#002366" centered dark>
            <v-tab>External Brokers</v-tab>
            <v-tab>Internal Brokers</v-tab>
          </v-tabs>
          <div class="d-flex">
            <v-btn color="#00004d" dark class="ml-auto ma-3 mr-3" @click="refreshData">
              <i style="color: #fff" class="flaticon2-refresh-1"></i>
            </v-btn>
          </div>
          <hr style="margin:0"/>
          <v-card-title>
            {{ activeTab === 0 ? 'External Brokers' : 'Internal Brokers' }} ({{ addTSBVZ(totalRecords) }})
            <v-spacer></v-spacer>
            <v-text-field
                @keydown.enter="searchQueryData"
                append-icon="search"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
          </v-card-title>
          <v-skeleton-loader :loading="loading" v-if="isLoaded" type="table"></v-skeleton-loader>
          <v-data-table
              :headers="headers"
              :items="items"
              :options.sync="pagination"
              :server-items-length="totalRecords"
              :footer-props="{
                itemsPerPageOptions: rowsPerPageItems,
                showFirstLastPage: true,
              }"
              :loading="loading"
              v-show="!isLoaded"
              mobile-breakpoint="100"
              class="elevation-0">
            <template v-slot:item.name="{ item }">
              <div class="text-truncate">
                <p>{{ item.name }}</p>
              </div>
            </template>
            <template v-slot:item.email="{ item }">
              <div class="text-truncate">
                <p>{{ item.email }}</p>
              </div>
            </template>
            <template v-slot:item.email_verified_at="{ item }">
              <v-chip
                  small
                  :color="isEmailVerified(item) ? 'success' : 'orange'"
                  text-color="white"
              >
                {{ isEmailVerified(item) ? 'Verified' : 'Unverified' }}
              </v-chip>
            </template>
            <template v-slot:item.number="{ item }">
              <div class="text-truncate">
                <p>{{ item.number || '—' }}</p>
              </div>
            </template>
            <template v-slot:item.agency_name="{ item }">
              <div class="text-truncate">
                <p>{{ item.agency_name || '—' }}</p>
              </div>
            </template>
            <template v-slot:item.broker_registration_number="{ item }">
              <div class="text-truncate">
                <p>{{ item.broker_registration_number || '—' }}</p>
              </div>
            </template>
            <template v-slot:item.documents_status="{ item }">
              <v-chip small :color="reviewChipColor(item.documents_status)" text-color="white">
                {{ reviewLabel(item.documents_status) }}
              </v-chip>
            </template>
            <template v-slot:item.image_status="{ item }">
              <v-chip small :color="reviewChipColor(item.image_status)" text-color="white">
                {{ reviewLabel(item.image_status) }}
              </v-chip>
            </template>
            <template v-slot:item.website_url_status="{ item }">
              <v-chip small :color="reviewChipColor(item.website_url_status)" text-color="white">
                {{ reviewLabel(item.website_url_status) }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-switch
                  v-if="hasPermission('brokers.update')"
                  v-model="item.status"
                  :color="Number(item.status) === 1 ? 'success' : ''"
                  :true-value="1"
                  :false-value="0"
                  @change="updateStatus($event, item.id)"
              ></v-switch>
              <v-chip
                  v-else
                  small
                  :color="Number(item.status) === 1 ? 'success' : 'grey'"
                  text-color="white"
              >
                {{ Number(item.status) === 1 ? 'Active' : 'Inactive' }}
              </v-chip>
            </template>
            <template v-slot:item.created_at="{ item }">
              <div class="text-truncate">
                {{ formatDateAndTime(item.created_at) }}
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                  v-if="hasPermission('brokers.view')"
                  color="#00004d"
                  dark
                  small
                  class="mr-2"
                  @click="openReviewDialog(item)"
              >
                Review
                <v-icon dark right small>fas fa-eye</v-icon>
              </v-btn>
              <v-btn
                  v-if="hasPermission('brokers.update') && !isEmailVerified(item)"
                  color="success"
                  dark
                  small
                  @click="verifyEmail(item)"
              >
                Verify Email
                <v-icon dark right small>fas fa-check</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </div>

    <v-dialog persistent v-model="reviewDialog" max-width="820px">
      <v-card v-if="brokerDetail">
        <i class="fas fa-times custom-times" @click="closeReviewDialog"></i>
        <v-card-title>
          Review — {{ brokerDetail.name }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <p class="mb-1"><strong>Email:</strong> {{ brokerDetail.email }}
                <v-chip class="ml-2" x-small :color="isEmailVerified(brokerDetail) ? 'success' : 'orange'" text-color="white">
                  {{ isEmailVerified(brokerDetail) ? 'Verified' : 'Unverified' }}
                </v-chip>
              </p>
              <div v-if="hasPermission('brokers.update') && !isEmailVerified(brokerDetail)" class="mb-2">
                <v-btn color="success" dark small @click="verifyEmail(brokerDetail)">Verify Email</v-btn>
              </div>
              <p class="mb-1"><strong>WhatsApp:</strong> {{ brokerDetail.number || '—' }}</p>
              <p class="mb-1"><strong>Agency:</strong> {{ brokerDetail.agency_name || '—' }}</p>
              <p class="mb-1"><strong>BRN:</strong> {{ brokerDetail.broker_registration_number || '—' }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="mb-2"><strong>Profile Photo</strong>
                <v-chip class="ml-2" x-small :color="reviewChipColor(brokerDetail.image_status)" text-color="white">
                  {{ reviewLabel(brokerDetail.image_status) }}
                </v-chip>
              </p>
              <div v-if="brokerDetail.image_url" class="mb-2">
                <img
                    :src="brokerDetail.image_url"
                    alt="Broker photo"
                    style="max-width: 160px; max-height: 160px; border-radius: 8px; object-fit: cover;"
                >
                <div class="mt-2">
                  <a :href="brokerDetail.image_url" target="_blank" rel="noopener noreferrer">Open Photo</a>
                </div>
              </div>
              <p v-else class="mb-2 grey--text">No profile photo uploaded.</p>
              <div v-if="brokerDetail.image_status === 'under_review' && hasPermission('brokers.update')">
                <v-btn color="success" dark small class="mr-2" @click="approveImage">Approve Photo</v-btn>
                <v-btn color="error" dark small @click="openReject('image')">Reject Photo</v-btn>
              </div>
              <p v-if="brokerDetail.image_status === 'rejected' && brokerDetail.image_reject_reason" class="mt-2 error--text">
                Reject reason: {{ brokerDetail.image_reject_reason }}
              </p>

              <v-divider class="my-3"></v-divider>

              <p class="mb-2"><strong>Website URL</strong>
                <v-chip class="ml-2" x-small :color="reviewChipColor(brokerDetail.website_url_status)" text-color="white">
                  {{ reviewLabel(brokerDetail.website_url_status) }}
                </v-chip>
              </p>
              <p v-if="brokerDetail.website_url" class="mb-2">
                <a :href="brokerDetail.website_url" target="_blank" rel="noopener noreferrer">{{ brokerDetail.website_url }}</a>
              </p>
              <p v-else class="mb-2 grey--text">No website URL submitted.</p>
              <div v-if="brokerDetail.website_url_status === 'under_review' && hasPermission('brokers.update')">
                <v-btn color="success" dark small class="mr-2" @click="approveWebsite">Approve Website</v-btn>
                <v-btn color="error" dark small @click="openReject('website')">Reject Website</v-btn>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <p class="mb-2">
            <strong>Documents</strong>
            <v-chip class="ml-2" x-small :color="reviewChipColor(brokerDetail.documents_status)" text-color="white">
              {{ reviewLabel(brokerDetail.documents_status) }}
            </v-chip>
          </p>
          <v-list dense>
            <v-list-item v-for="doc in brokerDetail.documents" :key="doc.field" class="mb-2">
              <v-list-item-content>
                <v-list-item-title>
                  {{ doc.label }}
                  <v-chip class="ml-2" x-small :color="reviewChipColor(doc.status)" text-color="white">
                    {{ reviewLabel(doc.status) }}
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ doc.uploaded ? 'Uploaded' : 'Not uploaded' }}
                </v-list-item-subtitle>
                <p v-if="doc.status === 'rejected' && doc.reject_reason" class="error--text mb-0 mt-1" style="white-space: normal;">
                  Reject reason: {{ doc.reject_reason }}
                </p>
              </v-list-item-content>
              <v-list-item-action class="flex-row align-center">
                <v-btn v-if="doc.uploaded" text small color="#00004d" class="mr-1" @click="viewDocument(doc)">View</v-btn>
                <template v-if="doc.status === 'under_review' && hasPermission('brokers.update')">
                  <v-btn color="success" dark x-small class="mr-1" @click="approveDocument(doc)">Approve</v-btn>
                  <v-btn color="error" dark x-small @click="openReject('document', doc)">Reject</v-btn>
                </template>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeReviewDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="rejectDialog" max-width="640px">
      <v-card>
        <i class="fas fa-times custom-times" @click="rejectDialog = false"></i>
        <v-card-title>
          Reject {{ rejectTitle }}
        </v-card-title>
        <v-card-text>
          <p class="mb-3">Please enter the rejection reason. This will be emailed to the broker.</p>
          <v-textarea
              v-model="rejectReason"
              outlined
              dense
              rows="4"
              counter="2000"
              maxlength="2000"
              label="Rejection Reason*"
              :rules="[v => !!(v && String(v).trim().length >= 3) || 'Reason must be at least 3 characters']"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="rejectDialog = false">Cancel</v-btn>
          <v-btn color="error" dark :disabled="!canSubmitReject" @click="confirmReject">
            Reject &amp; Email Broker
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
  USERS_LIST,
  GET_BROKER_DETAILS,
  APPROVE_BROKER_DOCUMENT,
  REJECT_BROKER_DOCUMENT,
  APPROVE_BROKER_IMAGE,
  REJECT_BROKER_IMAGE,
  APPROVE_BROKER_WEBSITE,
  REJECT_BROKER_WEBSITE,
  UPDATE_BROKER_STATUS,
  VERIFY_BROKER_EMAIL,
  CLEAR_USER_ERRORS,
} from "@/core/services/store/users.module";
import JwtService from "@/core/services/jwt.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

export default {
  name: 'brokersUsers',
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name', name: 'name', filterable: true, sortable: true},
        {text: 'Email', value: 'email', name: 'email', filterable: true, sortable: true},
        {text: 'Email Verified', value: 'email_verified_at', name: 'email_verified_at', filterable: false, sortable: true},
        {text: 'WhatsApp', value: 'number', name: 'number', filterable: true, sortable: true},
        {text: 'Agency', value: 'agency_name', name: 'agency_name', filterable: true, sortable: true},
        {text: 'BRN', value: 'broker_registration_number', name: 'broker_registration_number', filterable: true, sortable: true},
        {text: 'Documents', value: 'documents_status', name: 'documents_status', filterable: false, sortable: true},
        {text: 'Photo', value: 'image_status', name: 'image_status', filterable: false, sortable: true},
        {text: 'Website', value: 'website_url_status', name: 'website_url_status', filterable: false, sortable: true},
        {text: 'Status', value: 'status', name: 'status', filterable: false, sortable: true},
        {text: 'Created', value: 'created_at', name: 'created_at', filterable: true, sortable: true},
        {text: 'Actions', value: 'actions', name: 'actions', filterable: false, sortable: false},
      ],
      isLoaded: true,
      draw: 1,
      searchQuery: "",
      loading: true,
      activeTab: 0,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        itemsPerPage: 25,
        totalItems: 0,
        sortBy: ['created_at'],
        sortDesc: [true],
      },
      totalRecords: 0,
      rowsPerPageItems: [25, 50, 100, 150, 200],
      headerindex: "",
      columns: [],
      items: [],
      reviewDialog: false,
      brokerDetail: null,
      rejectDialog: false,
      rejectTarget: null,
      rejectDocument: null,
      rejectReason: "",
    }
  },
  watch: {
    activeTab() {
      if (this.pagination.page !== 1) {
        this.pagination.page = 1;
      }
    },
    params: {
      handler() {
        this.loadData().then(response => {
          this.items = response.items;
          this.totalRecords = response.total;
        });
      },
      deep: true
    },
  },
  mounted() {
    for (var i = 0; i < this.headers.length; i++) {
      this.columns.push(
          '&columns[' + i + '][data]=' + this.headers[i].value +
          '&columns[' + i + '][name]=' + this.headers[i].name +
          '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
          '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
          '&columns[' + i + '][search][value]=' +
          '&columns[' + i + '][search][regex]=' + false
      );
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Users Panel", route: "users"},
      {title: "Brokers"}
    ]);
  },
  computed: {
    params() {
      return {
        ...this.pagination,
        query: this.searchQuery,
        brokerFilter: this.activeTab === 0 ? 'external' : 'internal',
      };
    },
    canSubmitReject() {
      return String(this.rejectReason || '').trim().length >= 3;
    },
    rejectTitle() {
      if (this.rejectTarget === 'image') return 'Profile Photo';
      if (this.rejectTarget === 'website') return 'Website URL';
      if (this.rejectDocument && this.rejectDocument.label) return this.rejectDocument.label;
      return 'Document';
    },
  },
  methods: {
    reviewLabel(status) {
      const value = String(status || 'missing').toLowerCase();
      if (value === 'under_review') return 'Under Review';
      if (value === 'approved') return 'Approved';
      if (value === 'rejected') return 'Rejected';
      return 'Not Uploaded';
    },
    reviewChipColor(status) {
      const value = String(status || 'missing').toLowerCase();
      if (value === 'under_review') return 'orange';
      if (value === 'approved') return 'success';
      if (value === 'rejected') return 'error';
      return 'grey';
    },
    isEmailVerified(item) {
      if (!item) return false;
      const value = item.email_verified_at;
      return value !== null && value !== undefined && String(value).trim() !== '';
    },
    verifyEmail(item) {
      if (!item || !item.id || this.isEmailVerified(item)) return;
      this.$store.dispatch(CLEAR_USER_ERRORS);
      this.$store.dispatch(VERIFY_BROKER_EMAIL, item.id).then(() => {
        if (this.brokerDetail && this.brokerDetail.id === item.id) {
          this.reloadBrokerDetail();
        } else {
          this.refreshData();
        }
      });
    },
    refreshData() {
      this.loadData().then(response => {
        this.items = response.items;
        this.totalRecords = response.total;
      });
    },
    searchQueryData(e) {
      if (e.keyCode === 13) {
        this.searchQuery = e.target.value;
      }
    },
    getHeaderIndex(name) {
      let that = this;
      this.headers.filter(function (ele, i) {
        if (name == ele.name) {
          that.headerindex = i;
        }
      });
    },
    loadData() {
      this.loading = true;
      this.isLoaded = true;
      return new Promise((resolve) => {
        let params = this.params;
        params.length = params.itemsPerPage;
        params.start =
            params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1);
        params.draw = this.draw;
        let query = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
        this.getHeaderIndex(params.sortBy[0]);
        const createdAtIndex = this.headers.findIndex((h) => h.name === 'created_at');
        const orderColumn = params.sortBy.length === 0
            ? (createdAtIndex >= 0 ? createdAtIndex : 10)
            : this.headerindex;
        const orderDir = params.sortBy.length === 0
            ? 'desc'
            : (params.sortDesc[0] ? 'desc' : 'asc');
        query +=
            "&type=6" +
            "&broker_filter=" +
            (this.activeTab === 0 ? "external" : "internal") +
            "&search[value]=" +
            params.query +
            "&search[regex]=" +
            false +
            "&order[0][column]=" +
            orderColumn +
            "&order[0][dir]=" +
            orderDir;
        this.$store.dispatch(USERS_LIST, {q: query, columns: this.columns}).then((res) => {
          this.draw++;
          let items = res.records.data;
          let total = res.records.recordsFiltered;
          this.loading = !this.loading;
          this.isLoaded = !this.isLoaded;
          resolve({
            items,
            total
          });
        });
      });
    },
    openReviewDialog(item) {
      this.$store.dispatch(GET_BROKER_DETAILS, item.id).then((data) => {
        this.brokerDetail = data.records || null;
        this.reviewDialog = true;
      });
    },
    updateStatus(status, id) {
      this.$store.dispatch(CLEAR_USER_ERRORS);
      this.$store.dispatch(UPDATE_BROKER_STATUS, {
        slug: id,
        data: {status: status, column: 'status'},
      }).then(() => {
        this.refreshData();
      });
    },
    closeReviewDialog() {
      this.reviewDialog = false;
      this.brokerDetail = null;
    },
    reloadBrokerDetail() {
      if (!this.brokerDetail || !this.brokerDetail.id) return;
      this.$store.dispatch(GET_BROKER_DETAILS, this.brokerDetail.id).then((data) => {
        this.brokerDetail = data.records || null;
        this.refreshData();
      });
    },
    approveDocument(doc) {
      if (!this.brokerDetail || !doc) return;
      this.$store.dispatch(APPROVE_BROKER_DOCUMENT, {
        id: this.brokerDetail.id,
        field: doc.field,
      }).then(() => {
        this.reloadBrokerDetail();
      });
    },
    approveImage() {
      if (!this.brokerDetail) return;
      this.$store.dispatch(APPROVE_BROKER_IMAGE, this.brokerDetail.id).then(() => {
        this.reloadBrokerDetail();
      });
    },
    approveWebsite() {
      if (!this.brokerDetail) return;
      this.$store.dispatch(APPROVE_BROKER_WEBSITE, this.brokerDetail.id).then(() => {
        this.reloadBrokerDetail();
      });
    },
    openReject(target, doc = null) {
      this.rejectTarget = target;
      this.rejectDocument = doc;
      this.rejectReason = '';
      this.rejectDialog = true;
    },
    confirmReject() {
      if (!this.canSubmitReject || !this.brokerDetail) return;
      const reason = String(this.rejectReason).trim();

      if (this.rejectTarget === 'image') {
        this.$store.dispatch(REJECT_BROKER_IMAGE, {
          slug: this.brokerDetail.id,
          data: {reason},
        }).then(() => {
          this.rejectDialog = false;
          this.rejectReason = '';
          this.rejectTarget = null;
          this.rejectDocument = null;
          this.reloadBrokerDetail();
        });
        return;
      }

      if (this.rejectTarget === 'website') {
        this.$store.dispatch(REJECT_BROKER_WEBSITE, {
          slug: this.brokerDetail.id,
          data: {reason},
        }).then(() => {
          this.rejectDialog = false;
          this.rejectReason = '';
          this.rejectTarget = null;
          this.rejectDocument = null;
          this.reloadBrokerDetail();
        });
        return;
      }

      if (!this.rejectDocument || !this.rejectDocument.field) return;

      this.$store.dispatch(REJECT_BROKER_DOCUMENT, {
        id: this.brokerDetail.id,
        field: this.rejectDocument.field,
        data: {reason},
      }).then(() => {
        this.rejectDialog = false;
        this.rejectReason = '';
        this.rejectTarget = null;
        this.rejectDocument = null;
        this.reloadBrokerDetail();
      });
    },
    viewDocument(doc) {
      if (!doc || !doc.url) return;
      const base = (process.env.VUE_APP_ADMIN_API_URL || '').replace(/\/$/, '');
      const path = String(doc.url).replace(/^\//, '');
      axios.get(base + '/' + path, {
        responseType: 'blob',
        headers: {Authorization: `Bearer ${JwtService.getToken()}`},
      }).then((res) => {
        const blobUrl = window.URL.createObjectURL(res.data);
        window.open(blobUrl, '_blank', 'noopener,noreferrer');
      }).catch(() => {
        this.$store.dispatch(SET_SNACK, {clr: 'error', msg: 'Unable to open document.'});
      });
    },
  }
};
</script>
